
export const ADD_GENERAL_MESSAGE = 'ADD_GENERAL_MESSAGE';
export const REMOVE_GENERAL_MESSAGE = 'REMOVE_GENERAL_MESSAGE';